import Footer from '@/components/Ui-components/Common/footer';
// Server-rendered: the footer is the site's largest internal-link surface, so it
// must exist in the raw HTML rather than appearing a tick after hydration.
import LatestFooter from '@/components/Ui-components/latest-footer';

import {memo} from 'react';
import {renderLayoutMain} from '../main-layout/ProjectBrief';
const BlockchainLayout = (props: any) => {
    const {children} = props;
    return (
        <div className="blockchain-layout-wrapper">
            <main id="main-content" role="main">
                {children}
            </main>
            {renderLayoutMain()}
            <div className="margin">
                <LatestFooter />
            </div>

            <Footer />
        </div>
    );
};

export default memo(BlockchainLayout);
